import React from 'react';

import { Button } from '@mui/material';
import { observer } from 'mobx-react';
import { useToggle } from 'react-use';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './ManagePin.module.scss';
import { SetUpPinCodeModal } from './SetUpPinCodeModal/SetUpPinCodeModal';
import { entityInbodyPinCodeStore } from '../../../stores/entityInbodyPinCodeStore';

const ManagePin = observer(() => {
  const [isPinCodeModalOpen, togglePinCodeModalOpen] = useToggle(false);
  const [isPinVisible, togglePinVisible] = useToggle(false);

  const { pinCodeData } = entityInbodyPinCodeStore;

  const { enabled } = pinCodeData || {};

  if (!enabled) {
    return null;
  }

  return (
    <>
      {!pinCodeData?.pin ? (
        <Button variant="outlined" size="small" onClick={togglePinCodeModalOpen}>
          Set up PIN
        </Button>
      ) : (
        <div className={classes.pinContainer}>
          <div className={classes.pinInfo}>
            <TitleWithDescription
              title="PIN"
              titleFont="inherit"
              description={isPinVisible ? pinCodeData.pin : '****'}
              descriptionColor="main-black"
            />
            <Button variant="unstyled" onClick={togglePinVisible}>
              {isPinVisible ? (
                <VisibilityOffRoundedIcon color="tertiary" />
              ) : (
                <VisibilityRoundedIcon color="tertiary" />
              )}
            </Button>
          </div>
          <Button variant="outlined" size="small" onClick={togglePinCodeModalOpen}>
            Edit
          </Button>
        </div>
      )}
      <SetUpPinCodeModal open={isPinCodeModalOpen} onClose={togglePinCodeModalOpen} />
    </>
  );
});

export { ManagePin };
